import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { loadSuperbillFromStorage } from 'domains/superbillPDF/data/localStorage';
import { calculateSuperbillPDFProps } from 'pages/Superbill/PDF/calculateSuperbillPDFProps';
import { SuperbillPDFUI } from 'pages/Superbill/PDF/ui';

export const SuperbillPDF: React.FC = () => {
  const [superbill] = useState(loadSuperbillFromStorage());
  const { t } = useTranslation();

  if (!superbill) {
    throw new Error('Tried to access superbill PDF page but no results were found');
  }

  const props = calculateSuperbillPDFProps(superbill, t);

  return <SuperbillPDFUI {...props} />;
};
